import { memo } from 'react';
import SpanFeedbackTaskComponent from './SpanFeedbackTaskComponent';
import { StepViewComponentProps } from '../stepDescriptor/types';

function SpanFeedbackPinnedViewComponent(props: StepViewComponentProps) {
  return <SpanFeedbackTaskComponent {...props} isPinnable isPinnedView />;
}

export default memo(SpanFeedbackPinnedViewComponent);
